export default __webpack_public_path__ + "static/media/resume.9c5ea5a3.pdf";